import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from '@/lib/toast';
import { useAuth } from '@/contexts/AuthContext';

const ConfirmLogin = () => {
  const [processing, setProcessing] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    // If the user is authenticated, redirect to home
    if (isAuthenticated && !isLoading) {
      setTimeout(() => {
        navigate('/home');
      }, 1500);
    } else if (!isLoading && !localStorage.getItem('emailForSignIn')) {
      // If the auth process is done (not loading) and there's no email in localStorage 
      // and the user isn't authenticated, something went wrong
      setError('Unable to complete sign-in. Please try again.');
      setProcessing(false);
    }
    
    // Keep processing state true while authentication is in progress
    setProcessing(isLoading);
  }, [isAuthenticated, isLoading, navigate]);

  const handleTryAgain = () => {
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Confirming your login</CardTitle>
          <CardDescription>
            {processing 
              ? 'Please wait while we complete your sign-in process...' 
              : 'There was a problem with your sign-in'}
          </CardDescription>
        </CardHeader>
        <CardContent>
          {processing ? (
            <div className="flex justify-center py-6">
              <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
            </div>
          ) : (
            <div className="text-center py-6">
              <p className="text-destructive mb-4">{error}</p>
            </div>
          )}
        </CardContent>
        {!processing && (
          <CardFooter className="flex justify-center">
            <Button onClick={handleTryAgain}>Try Again</Button>
          </CardFooter>
        )}
      </Card>
    </div>
  );
};

export default ConfirmLogin;
